import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function Checksums() {
    return (
        <div className={globalStyles.article}>
            <h1>Checksums & hashing</h1>
            <p>Verify file integrity or detect changes — not to be confused with encryption
                (see the <b>Encryption</b> page for that).</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Command</th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>md5sum file</code></td>
                        <td>Fast, but MD5 is broken for security purposes — fine for casual integrity checks
                            only</td>
                    </tr>
                    <tr>
                        <td><code>sha256sum file</code></td>
                        <td>The common default for verifying downloads/releases</td>
                    </tr>
                    <tr>
                        <td><code>sha1sum file</code></td>
                        <td>Also broken for security use, still seen in older tooling</td>
                    </tr>
                    <tr>
                        <td><code>shasum -a 256 file</code></td>
                        <td>macOS/BSD equivalent of <code>sha256sum</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Generate & verify</h3>
            <pre className={globalStyles.code}>
                <code>
                    sha256sum *.tar.gz &gt; checksums.sha256<br/>
                    <br/>
                    <span style={{opacity: 0.7}}># On the receiving end</span><br/>
                    sha256sum -c checksums.sha256<br/>
                    <span style={{opacity: 0.7}}># archive.tar.gz: OK</span>
                </code>
            </pre>

            <h3>Comparing two files directly</h3>
            <pre className={globalStyles.code}>
                <code>
                    diff &lt;(sha256sum a.iso | cut -d' ' -f1) &lt;(sha256sum b.iso | cut -d' ' -f1)
                </code>
            </pre>

            <h3>Hashing a string</h3>
            <pre className={globalStyles.code}>
                <code>
                    echo -n "hello" | sha256sum
                </code>
            </pre>
            <p><code>-n</code> matters — without it, <code>echo</code> adds a trailing newline that changes
                the hash.</p>
        </div>
    )
}
